import { render, staticRenderFns } from "./default-settings.vue?vue&type=template&id=63a8c9b8&scoped=true"
import script from "./default-settings.vue?vue&type=script&lang=js"
export * from "./default-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a8c9b8",
  null
  
)

export default component.exports